import { isNil } from 'ramda';
import { useSelector } from 'react-redux';

import { mapTerms } from 'shared/components/offer_card_page.commercial/bargain_terms/internal/mappers/mapTerms';
import { offerSelector, selectIsAuthenticated } from 'shared/selectors';
import { isCoworkingSelector } from 'shared/selectors/offerData/offer/isCoworkingSelector';
import { IState } from 'shared/store';
import { getOfferType, isCommercial } from 'shared/utils/offer_type';

export interface IBargainTerm {
  name: string;
  value: string;
}

export interface IUseBargainTermsProps {
  title: string;
  terms: IBargainTerm[];
}

const withoutTermList = ['цена', 'ставка', 'налог', 'обеспечительный платеж'];

export const useBargainTermsProps = (): IUseBargainTermsProps | null => {
  const offer = useSelector(offerSelector);
  const knAuctionCompanies = useSelector((state: IState) => state.knAuctionCompanies);

  const isUserAuthenticated = useSelector(selectIsAuthenticated);
  const isCoworking = useSelector(isCoworkingSelector);

  let mapedTerms = useSelector(mapTerms);
  const cianUserId = offer.cianUserId;

  const offerType = getOfferType(offer);
  const isCommercialOffer = isCommercial(offerType);

  if (!isUserAuthenticated && (!isCoworking || !isCommercialOffer) && !mapedTerms.length) {
    return null;
  }
  const title = isCoworking ? 'Условия аренды' : 'Условия сделки';

  if (!isNil(cianUserId) && knAuctionCompanies.includes(cianUserId)) {
    mapedTerms = mapedTerms.filter(t => !withoutTermList.includes(t[0].toLowerCase()));
  }

  const terms: IBargainTerm[] = mapedTerms.map(term => {
    const value = Array.isArray(term[1]) ? term[1].join(' ') : term[1];

    return {
      name: term[0],
      value,
    };
  });

  return {
    title,
    terms,
  };
};
